import { render, staticRenderFns } from "./EditingZone.vue?vue&type=template&id=cdc33044&scoped=true&lang=pug&"
import script from "./EditingZone.vue?vue&type=script&lang=js&"
export * from "./EditingZone.vue?vue&type=script&lang=js&"
import style0 from "./EditingZone.vue?vue&type=style&index=0&id=cdc33044&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc33044",
  null
  
)

export default component.exports